<template>
  <Card
    :title="loggedIn ? $t('loggedIn.subline') : $t('loggedOut.subline')"
    :footerDivider="false"
  >
    <template v-slot:content>
      <p v-if="loggedIn" v-dompurify-html="$t('loggedIn.description')"></p>
      <p
        v-if="!loggedIn"
        v-dompurify-html="$t('loggedOut.description', { remainingSecondsBeforeRedirect })"
      ></p>
    </template>
    <template v-slot:footer>
      <div class="footer-cta footer-cta--left">
        <CustomButton
          v-if="loggedIn"
          @click="gotoOverview"
          buttonId="buttonOverview"
          :buttonColor="ButtonColor.LINK"
        >
          {{ $t('loggedIn.buttonOverview') }}
        </CustomButton>
        <CustomButton
          v-if="!loggedIn"
          buttonId="buttonLogin"
          @click.prevent="gotoLogin"
          :button-color="ButtonColor.PRIMARY"
        >
          {{ $t('loggedOut.buttonLogin') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'
import { navigate } from '@/utils/NavigationUtils'
import { onMounted, ref } from 'vue'
import { isAuthenticated } from '@/utils/KeycloakUtils'
import { useI18n } from 'vue-i18n'

const { t: $t } = useI18n()

const props = defineProps({
  addressChange: {
    type: Boolean,
    required: false,
    default: false
  },
  username: {
    type: String,
    required: false
  }
})

const loggedIn = ref(false)
const remainingSecondsBeforeRedirect = ref(10)

const gotoOverview = (): void => {
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.ACCOUNT_LOGIN_ON_SUCCESS_REDIRECT)
}

const gotoLogin = (): void => {
  if (props.addressChange) {
    navigate(globalThis.ENV_CONFIG?.REDIRECTS.PERSONAL_DATA_CHANGE_ADDRESS_PAGE, true)
  } else {
    navigate(globalThis.ENV_CONFIG?.REDIRECTS.LOGIN_PAGE, true)
  }
}

onMounted(() => {
  loggedIn.value = isAuthenticated()
  sessionStorage.clear()
  if (loggedIn.value === false) {
    if (props.username) {
      localStorage.setItem('loginHint', props.username)
    }
    startTimer()
  }
})

function startTimer() {
  remainingSecondsBeforeRedirect.value = 10
  setInterval(() => {
    remainingSecondsBeforeRedirect.value--
  }, 1000)

  setTimeout(() => {
    gotoLogin()
  }, 10 * 1000)
}
</script>
